import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { OptionValue } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { options } from 'components/common/GlobalFiltersInPage/components/lagLeadFilter/LagLeadFilter.consts';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string[];
    isSelected?: boolean;
}

export const LagLeadFilter = ({ name, methods, filtersStatusRef, handleFilters, value, isSelected = true }: Props) => {
    function arraysEqual(a: string[] = [], b: string[] = []) {
        return a?.length === b?.length && a.every((val, i) => val === b[i]);
    }

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const handleChange = (option: ISelectOption<OptionValue> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    return isSelected ? (
        <div data-testid={'battlecards-filters-lagLead'} className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string[]>>
                        id={'battlecards-lagLead'}
                        {...field}
                        value={options.find((option) => arraysEqual(option.value, value)) ?? null}
                        onChange={handleChange}
                        options={options}
                        isClearable={true}
                        label={FilterLabels.LAG_CARD_BOARD}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
